import {
    GET_DEVICE_REQUEST,
    GET_DEVICE_SUCCESS,
    GET_DEVICE_FAILURE,
    SET_DEVICE
} from '../actions/devices';

const initialState = {
    device: {},
    fetching: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_DEVICE_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_DEVICE_SUCCESS: {
            return {
                ...state,
                fetching: false,
                device: action.payload.device
            };
        }
        case GET_DEVICE_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_DEVICE: {
            return {
                ...state,
                device: action.payload.device
            };
        }
        default:
            return state;
    }
};
